import { render, staticRenderFns } from "./itemSet.vue?vue&type=template&id=95bf9082&"
import script from "./itemSet.vue?vue&type=script&lang=js&"
export * from "./itemSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports